import { DomManager } from "../../../managers/DOMManager";
import { ScreenMeasuringUnit } from "../../../types";
import { DomHelper } from "../../../utlis/DomHelper";
export class ScaleRuler {
    private container: HTMLElement;
    private horizontalRuler: HTMLElement;
    private verticalRuler: HTMLElement;
    private width:number = 0;
    private height:number = 0;
    private zoomValue:number = 1;
    private dpmmX: number = 96/25.4;
    private dpmmY:number = 96/25.4;
    private dpiX: number = 96; 
    private dpiY: number = 96; 
    private unit:ScreenMeasuringUnit = ScreenMeasuringUnit.inch;
    get pixelsPerMMX():number{
      return this.dpmmX;
    }
    get pixelsPerMMY():number{
      return this.dpmmY;
    }
    get zoomScale():number{
      return this.zoomValue;
    }
    constructor(containerId: string, measuringUnit:ScreenMeasuringUnit=ScreenMeasuringUnit.inch) {
      this.unit = measuringUnit;
      this.container = document.getElementById(containerId) as HTMLElement;
      this.container.classList.add('ruler-container');
      this.horizontalRuler = document.createElement("div");
      this.verticalRuler = document.createElement("div");

      this.getScreenDPI().then(({ dpiX, dpiY }) => {
        this.dpiX = dpiX;
        this.dpiY = dpiY;
        this.dpmmX = dpiX/25.4;
        this.dpmmY = dpiY/25.4;
        this.setupRulers(0,0);
      });
    }

    public destroy(){
      this.horizontalRuler.innerHTML = "";
      this.verticalRuler.innerHTML = "";
      this.container.style.marginLeft = "0px";
      this.container.style.marginTop = "0px";
      this.container.removeChild(this.horizontalRuler);
      this.container.removeChild(this.verticalRuler);
    }
  
    public getSizeInPixels(value:{width:number;height:number}, fromUnit:ScreenMeasuringUnit){        
        if(fromUnit == ScreenMeasuringUnit.cm){
            return {width: value.width * this.dpiX / 2.54, height: value.height * this.dpiY / 2.54 }
        }
        else if(fromUnit == ScreenMeasuringUnit.inch){
            return {width: value.width * this.dpiX, height: value.height * this.dpiY }
        }
        else{
           return value;
        }
    }
    private async getScreenDPI(): Promise<{ dpiX: number; dpiY: number }> {
      const divX = document.createElement("div");
      const divY = document.createElement("div");
  
      divX.style.width = "1in"; 
      divY.style.height = "1in"; 
      divX.style.position = divY.style.position = "absolute";
      divX.style.visibility = divY.style.visibility = "hidden";
  
      document.body.appendChild(divX);
      document.body.appendChild(divY);
  
      const dpiX = divX.offsetWidth; 
      const dpiY = divY.offsetHeight; 
  
      document.body.removeChild(divX);
      document.body.removeChild(divY);
  
      return { dpiX, dpiY };
    }
    public scroll(scrollLeft:number, scrollTop:number){
      this.refresh(scrollLeft, scrollTop);
    }
    public zoom(value:number){
      this.zoomValue = value;
      this.refresh();
      // DomManager.setZoom(this.horizontalRuler as HTMLDivElement,[value,1])     
      // this.horizontalRuler.style.width = `${this.width/value}px`
      // DomManager.setZoom(this.verticalRuler as HTMLDivElement,[1,value])
      // this.verticalRuler.style.height = `${this.height/value}px`
    }
    private setPosition(){
      const containerRect = this.container.getBoundingClientRect();
      const scrollTop = this.getScrollTop(this.container);
      const scrollLeft = this.getScrollLeft(this.container);
      const toolBoxRect  = DomHelper.getEl('#toolbox')?.getBoundingClientRect();
      const sidePanelWidth  = toolBoxRect?.width || 0;      

      const propBoxRect  = DomHelper.getEl('#property-container')?.getBoundingClientRect();
      const propPanelWidth  = toolBoxRect?.width || 0;      

      this.horizontalRuler.style.position = 'absolute'

      this.horizontalRuler.style.top = `${0}px`;
      this.horizontalRuler.style.left = `${sidePanelWidth + 20}px`;
      this.horizontalRuler.style.width = `calc(${100}%  - ${sidePanelWidth + propPanelWidth + 40}px)`;
      
      this.verticalRuler.style.position = 'absolute'
      this.verticalRuler.style.top = `${20}px`;
      this.verticalRuler.style.left = `${sidePanelWidth}px`;
      this.verticalRuler.style.height = `calc(${100}%  - 20px)`;      
    }
    private getOffsetTop(element: HTMLElement): number {
        let top = 0;
        let currentElement = element;
        
        while (currentElement) {
            top += currentElement.offsetTop;
            
            // handling for scrolling of parent containers
            if (currentElement.offsetParent) {
                top -= (currentElement.offsetParent as HTMLElement).scrollTop;
            }
            // handling margins of the current element
            const style = window.getComputedStyle(currentElement);
            top += parseInt(style.marginTop) || 0;
            
            currentElement = currentElement.offsetParent as HTMLElement;
        }
        return top;
    }
    private getScrollTop(element: HTMLElement): number {  
        let elementScrollTop = element.scrollTop;
       while (element.parentElement) {
          element = element.parentElement;
          elementScrollTop += element.scrollTop;
       }
        return elementScrollTop;
    }
    private getScrollLeft(element: HTMLElement): number {
        let elementScrollLeft = element.scrollLeft;
       while (element.parentElement) {
          element = element.parentElement;
          elementScrollLeft += element.scrollLeft;
       }
        return elementScrollLeft;
    }
    private getOffsetLeft(element: HTMLElement): number {
        let left = 0;
        let currentElement = element;
        
        while (currentElement) {
            left += currentElement.offsetLeft;
            
            // handling for scrolling of parent containers
            if (currentElement.offsetParent) {
                left -= (currentElement.offsetParent as HTMLElement).scrollLeft;
            }
            
            // handling margins of the current element
            const style = window.getComputedStyle(currentElement);
            left += parseInt(style.marginLeft) || 0;
            
            currentElement = currentElement.offsetParent as HTMLElement;
        }
        return left;
    }
    private setupRulers(scrollX:number, scrollY:number): void {

      this.container.style.marginLeft = "20px";
      this.container.style.marginTop = "20px";
      this.horizontalRuler.classList.add("ruler", "ruler-horizontal");
      this.verticalRuler.classList.add("ruler", "ruler-vertical");

      this.setPosition()
     
      this.container.appendChild(this.horizontalRuler);
      this.container.appendChild(this.verticalRuler);

      //DomManager.setZoom(this.horizontalRuler as HTMLDivElement,[1,1])  
      //DomManager.setZoom(this.verticalRuler as HTMLDivElement,[1,1])
      
      const hsbRect = this.horizontalRuler.getBoundingClientRect();
      this.width = hsbRect.width;
      const vsbRect = this.verticalRuler.getBoundingClientRect();
      this.height = vsbRect.height;
      //this.horizontalRuler.style.width = `${this.width/this.zoomValue}px`
      //this.verticalRuler.style.height = `${this.height/this.zoomValue}px`
      //DomManager.setZoom(this.horizontalRuler as HTMLDivElement,[this.zoomValue,1])  
      //DomManager.setZoom(this.verticalRuler as HTMLDivElement,[1,this.zoomValue])
      if(this.unit == ScreenMeasuringUnit.cm ){
        this.generateScale(scrollX,this.horizontalRuler, this.dpmmX * this.zoomValue, "mm"); 
        this.generateScale(scrollY,this.verticalRuler, this.dpmmY * this.zoomValue, "mm", true);
      }
      else if(this.unit == ScreenMeasuringUnit.pixel ){
        this.generateScale(scrollX, this.horizontalRuler, 1, "pixel"); 
        this.generateScale(scrollY, this.verticalRuler, 1, "pixel", true);
      }
      else{
        this.generateScale(scrollX, this.horizontalRuler, this.dpiX, "inch"); 
        this.generateScale(scrollY, this.verticalRuler, this.dpiY, "inch", true);
      }

      
    }
    public refresh(scrollX:number = 0, scrollY:number = 0): void {
      while(this.horizontalRuler.children.length>0){
        let lastItem = this.horizontalRuler.children[this.horizontalRuler.children.length-1];
        this.horizontalRuler.removeChild(lastItem);
        lastItem.innerHTML = "";
      }
      this.horizontalRuler.innerHTML = "";
      while(this.verticalRuler.children.length>0){
        let lastItem = this.verticalRuler.children[this.verticalRuler.children.length-1];
        this.verticalRuler.removeChild(lastItem);
        lastItem.innerHTML = "";
      }
      this.verticalRuler.innerHTML = "";
      this.setupRulers(scrollX, scrollY);
    }
    private generateScale( scrollSize:number, ruler: HTMLElement, unitSize: number, label: string, vertical: boolean = false){
      const maxSize = vertical ? this.height + scrollSize  : this.width + scrollSize ;
      const gap = (label === "pixel")?10:unitSize;
      for (let i = 0; i < maxSize; i += gap) {
        if(i<scrollSize){

        }
        else if(unitSize > 2 || Math.round(i / unitSize)%10 == 0){
          
          const tick = document.createElement("div");
          tick.classList.add("ruler-tick");
          tick.style[vertical ? "top" : "left"] = `${i - scrollSize}px`;
          tick.style[vertical ? "width" : "height"] = "12px"; 
    
          const tickLabel = document.createElement("span");
          if(Math.round(i / unitSize)%10 == 0)
          {
            tickLabel.textContent = `${Math.round(i / unitSize)/10}`;
            tickLabel.classList.add("ruler-tick-label");  
          }
          else if(unitSize > 6){
            tickLabel.textContent = `${Math.round(i / unitSize)%10}`;
            tickLabel.classList.add("ruler-minor-tick-label");  
          }
          
          if (vertical) {
            tick.style.height = "1px"; 
            tick.style.width = Math.round(i / unitSize) % 10 === 0 ? "12px" : "6px"; 
            tickLabel.style.left = Math.round(i / unitSize) % 10 === 0 ? "16px" : "10px";
            tickLabel.style.top = "-3px"; 
          } else {
            tick.style.width = "1px"; 
            tick.style.height = Math.round(i / unitSize) % 10 === 0 ? "12px" : "6px"; 
            tickLabel.style.top = Math.round(i / unitSize) % 10 === 0 ? "16px" : "10px";
            tickLabel.style.left = "-3px"; 
          }
          tick.appendChild(tickLabel);
          ruler.appendChild(tick);
        }
      }
    }
  }